import { Controller } from "@hotwired/stimulus"

/**
 * Focus the element as soon as it is connected (CONEK-7776, aisle checklist).
 *
 * After "No damage" / "Undo" the row is replaced over a Turbo Stream, which
 * removes the button that had focus — keyboard, VoiceOver and TalkBack users
 * would drop back to <body> in a list of 60 rows. The replaced row marks the
 * control that should take over (Undo after No damage, No damage after Undo).
 * Turbo does not honour `autofocus` on a stream replace, hence this controller.
 * `preventScroll`: the row is already where the user is looking.
 */
export default class extends Controller {
  connect() {
    this.element.focus({ preventScroll: true })
  }
}
